import { render, staticRenderFns } from "./insertPayment.vue?vue&type=template&id=820388e0"
import script from "./insertPayment.vue?vue&type=script&lang=js"
export * from "./insertPayment.vue?vue&type=script&lang=js"
import style0 from "./insertPayment.vue?vue&type=style&index=0&id=820388e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports